import { useUploadQueue } from "../context/UploadQueueContext";

export default function UploadStatusIndicator() {
  const { jobs } = useUploadQueue();
  if (!jobs.length) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 100000,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        width: 300,
        maxWidth: "calc(100vw - 40px)",
      }}
    >
      {jobs.map((job) => (
        <div
          key={job.id}
          style={{
            background: "#0a0c12",
            color: "#fff",
            borderRadius: 12,
            padding: "12px 16px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
            fontFamily: "Geist, sans-serif",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 6,
              gap: 8,
            }}
          >
            <div style={{ minWidth: 0 }}>
              <p
                style={{
                  margin: 0,
                  fontSize: 12,
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {job.placeName}
              </p>
              <p style={{ margin: 0, fontSize: 11, color: "rgba(255,255,255,0.6)" }}>
                {job.label}
              </p>
            </div>
            <span
              className="material-symbols-outlined"
              style={{
                fontSize: 18,
                color:
                  job.status === "error"
                    ? "#ff6b6b"
                    : job.status === "done"
                      ? "#4ade80"
                      : "rgba(255,255,255,0.7)",
                flexShrink: 0,
              }}
            >
              {job.status === "error"
                ? "error"
                : job.status === "done"
                  ? "check_circle"
                  : "cloud_upload"}
            </span>
          </div>
          {job.status === "uploading" && (
            <div
              style={{
                height: 4,
                background: "rgba(255,255,255,0.15)",
                borderRadius: 999,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: job.progress + "%",
                  background: "#4a7fd4",
                  borderRadius: 999,
                  transition: "width 0.3s",
                }}
              />
            </div>
          )}
          {job.status === "error" && (
            <p style={{ margin: 0, fontSize: 11, color: "#ff6b6b" }}>
              Upload failed. Try again.
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
